(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pv-filters"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit',event=>{const form=event.target;if(!(form instanceof HTMLFormElement)||!form.matches('[data-pv-tag-form]'))return;const tags=[...form.querySelectorAll('[data-pv-tag-choice]')].map(input=>input.value).filter(Boolean);form.action=form.dataset.collectionUrl+(tags.length?'/'+tags.map(encodeURIComponent).join('+'):'');});

document.addEventListener('click',event=>{const close=event.target.closest('[data-pv-filter-close]');if(close){const menu=close.closest('.pv-filter-disclosure');menu.open=false;menu.querySelector('summary').focus();}document.querySelectorAll('.pv-filter-disclosure[open]').forEach(menu=>{if(!menu.contains(event.target))menu.open=false;});});document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.pv-filter-disclosure[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus();});});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pv-gallery-viewer"] && !Shopify.designMode) return;
  try {
    function setupPVGallery(scope=document){
 scope.querySelectorAll('[data-pv-gallery-open]').forEach(opener=>{
  if(opener.dataset.ready)return;
  opener.dataset.ready='true';
  const section=opener.closest('.pv-collection');
  const dialog=opener.nextElementSibling;
  const pool=section?.querySelector('template[data-pv-gallery-pool]');
  if(!pool||!dialog?.matches('dialog')){opener.hidden=true;return;}
  const parse=template=>[...template.content.querySelectorAll('a[data-image]')].map(a=>({url:a.getAttribute('href'),image:a.dataset.image,title:a.dataset.title}));
  const items=parse(pool);
  if(!items.length){opener.hidden=true;return;}
  let index=0,shown=-1,request=0,nextPage=pool.dataset.next||'',pagePromise=null;
  const link=dialog.querySelector('.pv-gallery-image-link');
  const picture=dialog.querySelector('img');
  const previous=dialog.querySelector('[data-pv-gallery-prev]');
  const next=dialog.querySelector('[data-pv-gallery-next]');
  const close=dialog.querySelector('[data-pv-gallery-close]');
  const controls=()=>{previous.disabled=index===0;next.disabled=index===items.length-1&&!nextPage;};
  const more=async()=>{
   if(!nextPage)return;
   if(!pagePromise)pagePromise=(async()=>{
    const response=await fetch(nextPage,{credentials:'same-origin'});
    if(!response.ok)throw new Error('page');
    const doc=new DOMParser().parseFromString(await response.text(),'text/html');
    const template=doc.querySelector('template[data-pv-gallery-pool]');
    if(!template)throw new Error('pool');
    items.push(...parse(template));nextPage=template.dataset.next||'';
   })().finally(()=>{pagePromise=null;});
   return pagePromise;
  };
  const show=async target=>{
   const token=++request;dialog.setAttribute('aria-busy','true');
   try{
    if(target>=items.length&&nextPage)await more();
    if(token!==request||!dialog.open)return;
    index=Math.max(0,Math.min(target,items.length-1));controls();
    const item=items[index],image=new Image();image.src=item.image;await image.decode();
    if(token!==request||!dialog.open)return;
    picture.width=image.naturalWidth;picture.height=image.naturalHeight;picture.src=item.image;picture.alt=item.title;link.href=item.url;shown=index;
    const upcoming=items[index+1];if(upcoming){const preload=new Image();preload.src=upcoming.image;}
   }catch{index=Math.max(0,shown);controls();}
   finally{if(token===request)dialog.removeAttribute('aria-busy');}
  };
  opener.addEventListener('click',()=>{if(!window.matchMedia('(min-width:801px)').matches)return;dialog.showModal();document.documentElement.classList.add('pv-gallery-is-open');close.focus();show(index);});
  close.addEventListener('click',()=>dialog.close());
  previous.addEventListener('click',()=>show(index-1));next.addEventListener('click',()=>show(index+1));
  dialog.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();if(event.key==='ArrowLeft'&&!previous.disabled)show(index-1);if(event.key==='ArrowRight'&&!next.disabled)show(index+1);}});
  dialog.addEventListener('close',()=>{request++;dialog.removeAttribute('aria-busy');document.documentElement.classList.remove('pv-gallery-is-open');opener.focus();});
  window.addEventListener('pageshow',()=>{if(dialog.open)dialog.close();});
  controls();
 });
}
setupPVGallery();document.addEventListener('shopify:section:load',event=>setupPVGallery(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pv-header-localization"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{const langBtn=event.target.closest?.('.pv-langpill-panel button[data-pv-lang-cc]');if(langBtn){const form=langBtn.closest('form');const cc=form&&form.querySelector('[data-pv-cc]');if(cc&&langBtn.dataset.pvLangCc)cc.value=langBtn.dataset.pvLangCc;}document.querySelectorAll('.pv-langpill[open]').forEach(menu=>{if(!menu.contains(event.target))menu.open=false;});});
document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.pv-langpill[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus();});});
document.addEventListener('toggle',event=>{if(event.target.matches?.('.pv-langpill')&&event.target.open){document.querySelectorAll('.pv-nav-item[open]').forEach(menu=>menu.open=false);}if(event.target.matches?.('.pv-nav-item')&&event.target.open){document.querySelectorAll('.pv-langpill[open]').forEach(menu=>menu.open=false);}},true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pv-multibuy-offer"] && !Shopify.designMode) return;
  try {
    function updatePVMultiBuyAmounts(scope=document){
  const currency=window.Shopify?.currency;
  scope.querySelectorAll('[data-pv-discount-base]').forEach(offer=>{
    const target=offer.dataset.pvDiscountCurrency;
    const rate=target==='SEK'?1:(currency?.active===target?Number(currency.rate):NaN);
    if(!Number.isFinite(rate)||rate<=0)return;
    try{
      const amount=new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:target,minimumFractionDigits:0}).format(Number(offer.dataset.pvDiscountBase)*rate);
      offer.querySelector('[data-pv-discount-amount]').textContent=offer.dataset.pvDiscountTitle.replace('__PV_AMOUNT__',amount);
    }catch{}
  });
}
updatePVMultiBuyAmounts();
document.addEventListener('shopify:section:load',event=>updatePVMultiBuyAmounts(event.target));
window.addEventListener('pageshow',()=>updatePVMultiBuyAmounts());
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pv-product-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
  const opener = event.target.closest('[data-pv-quick-open]');
  if (opener) {
    event.preventDefault();
    const card = opener.closest('.pv-art-card');
    const panel = card && card.querySelector('[data-pv-quick]');
    if (!panel) return;
    document.querySelectorAll('[data-pv-quick]:not([hidden])').forEach((p) => { if (p !== panel) p.hidden = true; });
    panel.hidden = false;
    return;
  }

  const closer = event.target.closest('[data-pv-quick-close]');
  if (closer) {
    const panel = closer.closest('[data-pv-quick]');
    if (panel) panel.hidden = true;
    return;
  }

  const size = event.target.closest('[data-pv-quick] [data-pv-size]');
  if (size) {
    const panel = size.closest('[data-pv-quick]');
    panel.querySelectorAll('[data-pv-size]').forEach((b) => {
      b.classList.toggle('is-active', b === size);
      b.setAttribute('aria-selected', b === size ? 'true' : 'false');
    });
    panel.querySelector('[data-pv-quick-total]').textContent = size.dataset.price;
    panel.querySelector('[data-pv-atc]').dataset.pvAtc = size.dataset.variant;
    return;
  }

  if (!event.target.closest('[data-pv-quick]')) {
    document.querySelectorAll('[data-pv-quick]:not([hidden])').forEach((p) => { p.hidden = true; });
  }
});

document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-pv-quick] [data-pv-atc]');
  if (!button) return;
  event.preventDefault();
  if (button.dataset.busy === '1') return;
  button.dataset.busy = '1';
  const label = button.textContent;
  button.disabled = true;
  button.textContent = button.dataset.adding;
  const status = button.closest('[data-pv-quick]').querySelector('[data-pv-quick-status]');
  status.textContent = '';
  const root = window.Shopify.routes.root;
  try {
    const response = await fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(button.dataset.pvAtc), quantity: 1 }] }),
    });
    if (!response.ok) throw new Error('add failed');
    button.textContent = button.dataset.added;
    window.location.href = root + 'cart';
  } catch (error) {
    status.textContent = button.dataset.addError;
    button.textContent = label;
    button.disabled = false;
    button.dataset.busy = '';
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pv-size-scale"] && !Shopify.designMode) return;
  try {
    function initPrintavelleScale(scope=document){scope.querySelectorAll('[data-pv-scale]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const height=root.querySelector('[data-height]'),size=root.querySelector('[data-size]');function draw(){const h=Number(height.value),[w,p]=size.value.split(',').map(Number);if(!height.checkValidity()||!Number.isFinite(h)||h<100||h>220)return;root.querySelector('[data-person]').setAttribute('transform',`translate(40 ${225-h}) scale(${h/174})`);const rect=root.querySelector('[data-print]');rect.setAttribute('x',162.5-w/2);rect.setAttribute('y',105-p/2);rect.setAttribute('width',w);rect.setAttribute('height',p);root.querySelector('[data-size-label]').textContent=`${w} × ${p} cm`;root.querySelector('[data-height-label]').textContent=`${h} cm`;}height.addEventListener('input',draw);size.addEventListener('change',draw);draw();});}initPrintavelleScale();document.addEventListener('shopify:section:load',event=>initPrintavelleScale(event.target));
  } catch(e) { console.error(e); }
})();

})();
